import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import { spacing } from 'ui/theme/utils';

export const TextLink = ({ children, onClick, to, disabled, ...rest }) => {
  const history = useHistory();

  const handleClick = (event) => {
    if (disabled) {
      return;
    }
    if (onClick) {
      onClick(event);
    }
    history.push(to);
  };

  return (
    <Link {...rest} onClick={handleClick} disabled={disabled}>
      {children}
    </Link>
  );
};

const Link = styled.a`
  text-decoration: underline;
  font-size: 15px;
  letter-spacing: 0.7px;
  color: ${({ theme, color }) => color || theme.colors.grey};
  ${({ disabled }) => disabled && `opacity: 0.5;`}
  ${(props) => spacing(props)}
`;
